
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import { Dashboard } from './Component/Dashboard/Dashboard';
import { AddWorker } from './Component/AddWorker';
import { CancelledList } from './Component/CancelledList';
import { CompletedRequestList } from './Component/CompletedRequestList';
import { CustomerList } from './Component/CustomerList';
import { EnquiryList } from './Component/EnquiryList';
import { MassagePricing } from './Component/MassagePricing';
import { MassiveRequestList } from './Component/MassiveRequestList';
import { OnGoingRequestList } from './Component/OnGoingRequestList';
import { TotalRequestList } from './Component/TotalRequestList';
import { Login } from './Component/Login';
import { RateTemplete } from "./Component/RateTamplete";
import { RateTemplateList } from "./Component/RateTemplateList";
import { UpdateWorker } from "./Component/UpdateWorker";
import { UpdateRateTemplate } from "./Component/UpdateRateTemplate";
import { StaffList } from "./Component/StaffList";
import { OrderList } from "./Component/OrderList";
import OrderDetails from "./Component/OrderDetails";

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/" element={<Login />} />
      <Route path="/addstaff" element={<AddWorker />} />
      <Route path="/stafflist" element={<StaffList/>} />
      <Route path="/cancelledList" element={<CancelledList />} />
      <Route path="/completedRequestList" element={<CompletedRequestList />} />
      <Route path="/customerList" element={<CustomerList />} />
      <Route path="/enquiryList" element={<EnquiryList />} />
      <Route path="/massagePricing" element={<MassagePricing />} />
      <Route path="/massiveRequestList" element={<MassiveRequestList />} />
      <Route path="/ongoingRequestList" element={<OnGoingRequestList />} />
      <Route path="/totalRequestList" element={<TotalRequestList />} /> 
      <Route path="/ratetemplete" element={<RateTemplete />} /> 
      <Route path="/ratetempletelist" element={<RateTemplateList />} />
      <Route path="/orderlist" element={<OrderList />} />
      <Route path="/orderDetails" element={<OrderDetails />} />

      <Route path="/activerate" element={<CancelledList />} />


       



{/* ............................<Update Routing>........................... */}


      <Route path="/updateworker/:staff_id" element={<UpdateWorker />} /> 
      <Route path="/updateratetemplete/:template_id" element={<UpdateRateTemplate />} /> 




    </Routes>
  </BrowserRouter>
  );
}

export default App;
   